import { Container, Title, Text, Stack } from '@mantine/core';

export function TermsOfService() {
  return (
    <Container size="md" py="xl" mt={20} sx={{ minHeight: 'calc(100vh - 60px)' }}>
      <Stack spacing="lg">
        <Title order={1}>Terms of Service</Title>
        
        <Text>Last updated: March 2024</Text>

        <Stack spacing="md">
          <Title order={2}>1. Acceptance of Terms</Title>
          <Text>
            By accessing and using the Report Management System, you agree to be bound by these Terms of Service.
            If you do not agree to these terms, please do not use the service.
          </Text>

          <Title order={2}>2. Use of Service</Title>
          <Text>
            The Report Management System is provided for managing and submitting reports. Users must maintain
            the confidentiality of their account credentials and are responsible for all activities under their account.
          </Text>

          <Title order={2}>3. Data Privacy</Title>
          <Text>
            We are committed to protecting your data privacy. Please refer to our Privacy Policy for detailed
            information about how we collect, use, and protect your data.
          </Text>

          <Title order={2}>4. Service Modifications</Title>
          <Text>
            We reserve the right to modify or discontinue the service at any time. We will provide reasonable
            notice of any significant changes that affect your use of the service.
          </Text>

          <Title order={2}>5. Limitation of Liability</Title>
          <Text>
            The Report Management System is provided "as is" without warranties of any kind. We are not liable
            for any damages arising from your use of the service.
          </Text>
        </Stack>
      </Stack>
    </Container>
  );
} 